import blinkabla from "../media/blinkabla.png";
import freelance from "../media/freelance.png";
import edument from "../media/edument_logo_square.png";

export const workdata = [
  {
    title: "Edument AB",
    platform: "Konsult Fullstackutvecklare",
    skills:
      "Fick uppdrag hos elbolaget Öresundskraft och har varit en del i deras team för att utveckla en ny energiapp i React Native. Efter release av appen har jag suttit med deras webblösningar som är i byggda i .NET med Optimizely som CMS. Jag har även fått lära mig att arbeta med Azure DevOps och CI/CD-pipelines.",
    image: edument,
    date: "Sept 2024 - ",
    credential: "https://www.edument.se/",
    id: 0,
  },
  {
    title: "Frilansande webbutvecklare",
    platform: "Fullstackutvecklare",
    skills:
      "Byggde enklare websidor i .NET och Node.JS. Se portfolio för kundprojekt.",
    image: freelance,
    date: "April 2024 - Aug 2024",
    credential: "",
    id: 1,
  },
  {
    title: "Blinka Blå AB",
    platform: "Fullstackutvecklare",
    skills:
      "En del i ett utvecklarteam som arbetade agilt med att bygga upp större websidor i .NET med Umbraco som CMS. Jag fick även vara handledare för utvecklarpraktikanter. Frontendstacken inkluderade bland annat: React, Vue, Tailwind, SASS, PostCSS, Webpack och Fontello. På backendsidan fick jag arbeta med SQL, IIS, Azure och .NET Core. Jag fick även lära mig att arbeta med WCAG och att skriva tillgänglig kod.",
    image: blinkabla,
    date: "Aug 2023 - April 2024",
    credential: "https://www.blinkabla.se/",
    id: 2,
  },
  {
    title: "Blinka Blå AB",
    platform: "Praktikant",
    skills:
      "Jag fick lära mig att bygga hemsidor på .NET-platformen med Umbraco som CMS. Jag fick också lära mig mycket om hur man sätter upp en utvecklarmiljö, inklusive konfigurering databas, server (IIS) och frontend. Jag fick även lära mig Tailwind, PostCSS och tränat mina CSS-kunskaper.",
    image: blinkabla,
    date: "Juni 2023 - Aug 2023",
    credential: "https://www.blinkabla.se/",
    id: 3,
  },
];
